import React, { Component } from 'react';
import { Alert, Card, CardBody, Input, Spinner, Table } from 'reactstrap';

import { CourseEntitlementAPI } from "api";

const moment = require("moment");

/**
 * I VIDEOCORSI APERTI A QUESTO CORSISTA — il piano SMART.
 *
 * ┌─ 🔴 PERCHE' NON SONO VENDITE ────────────────────────────────────────────────────────┐
 * │                                                                                      │
 * │ SMART e' un abbonamento mensile che vive su ATOM, dove stanno i soldi. Una vendita    │
 * │ su CLTV per rappresentarlo entrerebbe nel fatturato, negli elenchi vendite e nei      │
 * │ conti per prodotto di questo gestionale — che parlano di soldi incassati da CLTV, e   │
 * │ questi non lo sono.                                                                   │
 * │                                                                                      │
 * │ E una vendita punta a UN corso solo: SMART ne apre tanti, scelti uno per uno.         │
 * │ Il diritto vive in `course_entitlements`, e questa e' l'unica schermata da cui si     │
 * │ apre e si chiude.                                                                     │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 */
class TabVideocorsi extends Component {

    constructor(props) {
        super(props);
        this.state = { caricando: true, errore: false, corsi: [], salvando: null };
    }

    componentDidMount() {
        this.carica();
    }

    /**
     * 🔴 L'IDENTIFICATIVO E' IL `clients.id`, NON QUELLO DELLA SCHEDA.
     *
     * `this.props.client.id` e' un `users.id`: questa scheda ha User come modello di testa e
     * ci fonde sopra i campi di Client. Le rotte dei diritti vogliono il `clients.id`, che il
     * backend manda come `id_client`.
     *
     * ⚠️ NIENTE RIPIEGO SU `id` SE MANCA, ed e' il punto di questa funzione. I due contatori
     * corrono nelle stesse fasce di numeri: un `users.id` mandato al posto di un `clients.id`
     * non da' errore, trova la riga di UN'ALTRA PERSONA e le apre un videocorso, con la
     * schermata che dice «fatto». Meglio una linguetta che si rifiuta di funzionare.
     */
    idCliente = () => {
        const id = this.props.client.id_client;
        return (typeof id === "number" && id > 0) ? id : null;
    };

    carica = () => {
        const id = this.idCliente();

        if (id === null) {
            this.setState({ caricando: false, errore: true });
            return;
        }

        this.setState({ caricando: true, errore: false });

        CourseEntitlementAPI.list(id)
            .then((r) => this.setState({ corsi: r.courses || [], caricando: false }))
            .catch((e) => {
                console.error(e);
                this.setState({ caricando: false, errore: true });
            });
    };

    /**
     * La spunta: aperta la chiude, chiusa la apre.
     *
     * ⚠️ Si rilegge dal server invece di aggiornare la spunta da soli: aprire un corso puo'
     * anche RIAPRIRNE uno sospeso, e in quel caso cambia anche la riga rossa sotto il nome.
     * Indovinare il risultato mostrerebbe una schermata che non corrisponde ai dati.
     */
    cambia = (corso) => {
        const id = this.idCliente();
        if (id === null) return;

        this.setState({ salvando: corso.id });

        const azione = corso.aperto
            ? CourseEntitlementAPI.close(id, corso.id)
            : CourseEntitlementAPI.open(id, corso.id);

        azione
            .then(() => {
                this.setState({ salvando: null });
                this.carica();
            })
            .catch((e) => {
                console.error(e);
                this.setState({ salvando: null });
                global.SweetAlert.fire({
                    icon: 'error',
                    title: 'Non ha funzionato',
                    text: 'Il corso non e\' stato cambiato. Riprova.',
                    customClass: { confirmButton: 'btn btn-primary' }
                });
            });
    };

    render() {
        const { caricando, errore, corsi, salvando } = this.state;

        if (caricando)
            return <div className="text-center p-5"><Spinner color="primary" /></div>;

        /* Due guasti diversi, due frasi diverse: «manca l'anagrafica» si risolve in un modo,
           «non riesco a leggere» in un altro. Dare la stessa frase a tutti e due manderebbe a
           cercare dalla parte sbagliata. */
        if (errore)
            return this.idCliente() === null
                ? <Alert color="danger">
                    Questa scheda non ha un'anagrafica cliente collegata, quindi i videocorsi
                    non si gestiscono da qui. Se l'utente <b>e'</b> un corsista, il backend non
                    sta ancora mandando <code>id_client</code>: va rilasciato.
                  </Alert>
                : <Alert color="danger">Non e' stato possibile leggere i videocorsi.</Alert>;

        const nessunoAperto = corsi.every((c) => !c.aperto);

        return (
            <React.Fragment>

                {/* Chi apre un corso da qui deve sapere che non sta passando da ATOM, e che
                    nessuno sta incassando. Sta a schermo e non solo in questo commento. */}
                <Alert color="warning" className="d-flex align-items-start">
                    <i className="ri-alert-line fs-20 me-2"></i>
                    <div>
                        Quello che apri qui <b>non passa da ATOM</b>: il corsista vedra' il
                        corso e dall'altra parte non risultera' nessun contratto, quindi
                        nessuno stara' incassando.
                    </div>
                </Alert>

                {/* 🔴 LA SPIA DELLA FINESTRA VUOTA. Il ponte non apre nessun corso al
                    pagamento: fra l'incasso su ATOM e questa spunta il corsista ha pagato e
                    vede una libreria vuota, e nessuno sa quanto dura. Un elenco tutto spento
                    sembra normale; questo riquadro no. */}
                {nessunoAperto && (
                    <Alert color="danger">
                        <b>Nessun corso aperto.</b> Se ha appena pagato un piano con i
                        videocorsi, in questo momento <b>sta vedendo una libreria vuota</b>.
                    </Alert>
                )}

                <Card>
                    <CardBody>
                        <Table className="align-middle mb-0">
                            <tbody>
                            {corsi.map((c) => (
                                <tr key={c.id}>
                                    <td style={{ width: 40 }}>
                                        <Input
                                            type="checkbox"
                                            checked={c.aperto}
                                            disabled={salvando === c.id}
                                            onChange={() => this.cambia(c)} />
                                    </td>
                                    <td>
                                        <b>{c.name}</b>
                                        {c.enabled === false && (
                                            <span className="badge bg-secondary ms-2">non pubblicato</span>
                                        )}

                                        {c.aperto && c.createdAt && (
                                            <div className="text-muted small">
                                                aperto il {moment(c.createdAt).format("DD/MM/YYYY")}
                                                {c.granted_by ? (" da " + c.granted_by) : ""}
                                            </div>
                                        )}

                                        {/* Un corso SOSPESO non e' un corso chiuso: la riga c'e'
                                            ancora, l'ha spenta il ponte perche' il cliente non paga
                                            piu'. Dirlo evita che qualcuno lo riapra senza sapere
                                            perche' era spento. */}
                                        {!c.aperto && c.suspended_at && (
                                            <div className="text-danger small">
                                                sospeso: {c.suspended_reason || 'motivo non indicato'}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default TabVideocorsi;
